import { render, staticRenderFns } from "./轮播新闻.vue?vue&type=template&id=ee5ad8a6&scoped=true"
import script from "./轮播新闻.vue?vue&type=script&lang=js"
export * from "./轮播新闻.vue?vue&type=script&lang=js"
import style0 from "./轮播新闻.vue?vue&type=style&index=0&id=ee5ad8a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5ad8a6",
  null
  
)

export default component.exports